import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ErrorHandler from '../../../../Helpers/Errors/ErrorHandler';
import { httpRequest } from '../../../../../httpRequest';
import { CUSTOMER_CODE } from '../../../../Common/Constant';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../../sessionStorage';
import QuoteCoverageDetails from '../SubComponents/QuoteCoverageDetails';
import QuoteResult from '../SubComponents/QuoteResult';
import States from '../../../../Helpers/Lists/States';
import { ConvertStringToBoolean } from '../../../../Helpers/Formatters/ConvertBoolean';
import { checkPiAgeIsMatchWithAgeLimit } from '../../SubComponents/SelectOptions';
import Alerts from '../../../../Helpers/Alerts/Alerts';
import './Quoter.scss';

export default function Quoter(props) {

    const [loading, setLoading] = useState(false);
    const [quoteResults, setQuoteResults] = useState([]);
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const isSurvivorshipPolicyType = props.isSurvivorshipPolicy;
    const ONECLICKTYPEID_MS_ABLTC = 35;
    const additionalWarnings = (quoteResults && quoteResults.additionalWarnings && quoteResults.additionalWarnings.length > 0) ? quoteResults.additionalWarnings : null;
    const warningMessage = additionalWarnings && additionalWarnings.find(warning => warning === "Nationwide CareMatters Together is not available for MT and NY.");;

    const runQuote = (getIsSubscribed) => {
        if (props.basicInfo === null || props.basicInfo === undefined) {
            props.history.push('/Products/ABLTC/');
        }

        const insuredInfoDetails = props.basicInfo && props.basicInfo.pages && props.basicInfo.pages.insuredBasicInfo.insuredInfo;
        const queryParams = {
            firstName: insuredInfoDetails[0].proposedInsuredFirstName,
            lastName: insuredInfoDetails[0].proposedInsuredLastName,
            dateOfBirth: insuredInfoDetails[0].birthdate,
            gender: insuredInfoDetails[0].gender,
            stateCode: insuredInfoDetails[0].state,
            stateName: States().find((e) => e.value === insuredInfoDetails[0].state).label,
            county: insuredInfoDetails[0].state === 'CA' ? insuredInfoDetails[0].county : '',
            maritalStatus: insuredInfoDetails[0].maritalStatus,
            tobacco: ConvertStringToBoolean(insuredInfoDetails[0].tobacco),
            premium: props.formState.coverageAmount,
            inflationBenefitOption: props.formState.infBenefit || props.basicInfo.pages.clientCoverage.infBenefit,
            premiumMode: props.formState.premiumMode || props.basicInfo.pages.clientCoverage.premiumMode,
            benefitDuration: props.formState.benefitDuration || props.basicInfo.pages.clientCoverage.benefitDuration,
            returnOfPremium: props.formState.returnPremium !== null ? props.formState.returnPremium : (props.basicInfo ? props.basicInfo.pages.clientCoverage.returnPremium : false),
            interestRate: props.formState.interestRate || props.basicInfo.pages.clientCoverage.interestRate,
            healthClass: "Preferred",
            sessionId: accountObj.sessionId,
            oneClickAccountId: accountObj.account.oneClickAccountId,
            oneClickTypeId: ONECLICKTYPEID_MS_ABLTC,
            survivorFirstName: (isSurvivorshipPolicyType && insuredInfoDetails[1].proposedInsuredFirstName) || '',
            survivorLastName: (isSurvivorshipPolicyType && insuredInfoDetails[1].proposedInsuredLastName) || '',
            survivorDateOfBirth: isSurvivorshipPolicyType ? insuredInfoDetails[1].birthdate : null,
            survivorGender: (isSurvivorshipPolicyType && insuredInfoDetails[1].gender) || '',
            survivorState: (isSurvivorshipPolicyType && insuredInfoDetails[1].state) || '',
            survivorCounty: (isSurvivorshipPolicyType && insuredInfoDetails[1].state === 'CA' ? insuredInfoDetails[1].county : '') || '',
            survivorMaritalStatus: (isSurvivorshipPolicyType && insuredInfoDetails[1].maritalStatus) || '',
            survivorTobacco: isSurvivorshipPolicyType ? ConvertStringToBoolean(insuredInfoDetails[1].tobacco) : false,
            survivorHealthClass: "Preferred",
            isSurvivorshipPolicyType: isSurvivorshipPolicyType,
            customer: CUSTOMER_CODE,
            enableABLTCJohnHancockLifeCare: accountObj.msEnableABLTCJohnHancockLifeCare || false,
        };
        httpRequest.post(`${covrServicesUrl}/api/HybridLTC/GetHybridQuote`, queryParams)
            .then((data) => {
                if (getIsSubscribed()) {
                    setQuoteResults(data);
                    data.quotes.forEach((index) => {
                        index.premiumMode = props.formState.premiumMode;
                        index.benefitDuration = props.formState.benefitDuration;
                        index.infBenefit = props.formState.infBenefit;
                        index.coverageAmount = props.formState.coverageAmount;
                        index.interestRate = props.formState.interestRate;
                        index.returnPremium = props.formState.returnPremium;
                        index.oneClickTypeId = ONECLICKTYPEID_MS_ABLTC;
                    });
                    props.onFieldChange('selectedQuotes', data.quotes)
                    setLoading(false);
                }
            })
            .catch((error) => {
                if (getIsSubscribed()) {
                    ErrorHandler(error, setQuoteResults);
                    setLoading(false);
                }
            });
    };

    let debounce = null;
    useEffect(() => {
        setLoading(true);
        let fullForm = props.basicInfo;
        fullForm.pages.quoter.coverageAmount ? null : fullForm.pages.quoter.coverageAmount = parseInt(fullForm.pages.clientCoverage.coverageAmount, 10);
        fullForm.pages.quoter.premiumMode ? null : fullForm.pages.quoter.premiumMode = fullForm.pages.clientCoverage.premiumMode;
        fullForm.pages.quoter.benefitDuration ? null : fullForm.pages.quoter.benefitDuration = fullForm.pages.clientCoverage.benefitDuration;
        fullForm.pages.quoter.infBenefit ? null : fullForm.pages.quoter.infBenefit = fullForm.pages.clientCoverage.infBenefit;
        fullForm.pages.quoter.interestRate ? null : fullForm.pages.quoter.interestRate = fullForm.pages.clientCoverage.interestRate;
        fullForm.pages.quoter.returnPremium != null ? null : fullForm.pages.quoter.returnPremium = fullForm.pages.clientCoverage.returnPremium;
        fullForm.pages.quoter.productType = props.productType;
        props.onMultiFieldChange(fullForm);
        if (props.formState.coverageAmount === null) {
            return;
        }

        let isSubscribed = true;

        if (debounce) {
            clearTimeout(debounce);
        }

        debounce = setTimeout(() => runQuote(() => isSubscribed), 2000);

        return () => {
            clearTimeout(debounce);
            isSubscribed = false;
        };
    }, [props.formState.premiumMode, props.formState.coverageAmount, props.formState.infBenefit, props.formState.benefitDuration, props.formState.returnPremium, props.formState.interestRate]);

    const handleOnFieldChange = (field, value) => {
        let fullForm = { ...props.basicInfo }
        fullForm.pages.quoter = {
          ...fullForm.pages.quoter,
          [field]: value
        }
        
        //update data in client coverage as per quoter page
        const assetBasedQuoter = fullForm.pages.quoter;
        if (fullForm && fullForm.pages && fullForm.pages.clientCoverage) {
          fullForm.pages.clientCoverage = {
            ...fullForm.pages.clientCoverage,
            coverageAmount: parseInt(assetBasedQuoter.coverageAmount, 10),
            premiumMode: assetBasedQuoter.premiumMode,
            benefitDuration: assetBasedQuoter.benefitDuration,
            infBenefit: assetBasedQuoter.infBenefit,
            interestRate: assetBasedQuoter.interestRate,
            returnPremium: assetBasedQuoter.returnPremium,
          }
          props.onMultiFieldChange(fullForm);
        }
    }

    const renderAlertMessage = (message) => {
        return <Alerts
            severity="warning"
            message={message}
            className="bg-transparent text-reset p-0 mb-2"
        />
    }

    return (
        <div className='mt-n4'>
            {warningMessage &&
                renderAlertMessage(warningMessage)
            }
            <Row className="quoter px-3">
                <Col lg={4} className="mb-3 p-0">
                    <QuoteCoverageDetails
                        onFieldChange={(field, value) => handleOnFieldChange(field, value)}
                        formState={props.formState}
                        fullFormState={props.basicInfo}
                        isPiAgeIsMetWithAgeLimit={checkPiAgeIsMatchWithAgeLimit(props.formState.premiumMode, props.basicInfo.pages, isSurvivorshipPolicyType)}
                        loading={loading}
                        isSurvivorshipPolicyType={isSurvivorshipPolicyType}
                        history={props.history}
                    />

                </Col>
                <Col lg={8}>
                    <QuoteResult
                        formState={props.formState}
                        quoteResults={quoteResults}
                        loading={loading}
                        onNext={props.onNext}
                        fullFormState={props.basicInfo}
                        onMultiFieldChange={props.onMultiFieldChange}
                        isSurvivorshipPolicyType={isSurvivorshipPolicyType}
                        isPiAgeIsMetWithAgeLimit={checkPiAgeIsMatchWithAgeLimit(props.formState.premiumMode, props.basicInfo.pages, isSurvivorshipPolicyType)}
                    />
                </Col>
            </Row>
        </div>
    );
}

Quoter.propTypes = {
    formState: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
};

Quoter.DefaultFormState = () => {
    return {
        coverageAmount: null,
        premiumMode: null,
        benefitDuration: null,
        infBenefit: null,
        interestRate: null,
        returnPremium: null,
        productType: "",
        selectedQuotes: []
    };
};



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/Steps/Quoter.js